import { styled } from "@mui/material/styles";
const ChatTabsMain = styled("div")(({ theme }) => ({
  marginTop: "20px",
}));
const ChatTabsLiks = styled("div")(({ theme }) => ({
  margin: "0 auto",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
  [theme.breakpoints.up("md")]: {
    width: "70%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "60%",
  },
  display: "flex",
  justifyContent: "space-between",
  borderBottom: "2px solid #E8E8E8",
  paddingBottom: "4px",
  "& button": {
    background: "none",
    border: "none",
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: "18px",
    lineHeight: "33px",
    cursor: "pointer",
    textAlign: "center",
    color: "rgba(11, 11, 11, 0.5)",
    fontFamily: theme.typography.fontFamily,
    position: "relative",
    "&.active": {
      color: "#0B0B0B",
    },
    "&.active::after": {
      content: "''",
      position: "absolute",
      bottom: "-6px",
      width: "calc(100% + 10px)",
      height: "2px",
      background: "#0B0B0B",
      left: 0,
    },
  },
}));

export { ChatTabsMain, ChatTabsLiks };
